import React, { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { SavingsCalculator } from './pages/SavingsCalculator';
import { Blog } from './pages/Blog';
import { Contact } from './pages/Contact';
import { ResidentialSolar } from './pages/solutions/ResidentialSolar';
import { CommercialSolar, HousingSocietySolar, OnGridSolar, OffGridSolar } from './pages/solutions/AllSolutions';
import { Solar101, OnGridVsOffGrid, GovernmentSubsidies, MistakesToAvoid } from './pages/blog/BlogArticles';

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/savings-calculator" element={<SavingsCalculator />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/solar-101-how-rooftop-solar-works" element={<Solar101 />} />
          <Route path="/blog/on-grid-vs-off-grid-vs-hybrid" element={<OnGridVsOffGrid />} />
          <Route path="/blog/government-solar-subsidies" element={<GovernmentSubsidies />} />
          <Route path="/blog/5-mistakes-to-avoid" element={<MistakesToAvoid />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/solutions/residential-solar" element={<ResidentialSolar />} />
          <Route path="/solutions/commercial-solar" element={<CommercialSolar />} />
          <Route path="/solutions/housing-society-solar" element={<HousingSocietySolar />} />
          <Route path="/solutions/on-grid-solar" element={<OnGridSolar />} />
          <Route path="/solutions/off-grid-solar" element={<OffGridSolar />} />
        </Routes>
        <Footer />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
